// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".print-link[data-v-5e8b8739]{font-size:1.2em}", "",{"version":3,"sources":["webpack://./resources/js/components/trainings/ProviderTrainingCertificatePrint.vue"],"names":[],"mappings":"AACI,6BACI,eAAR","sourcesContent":["\n    .print-link {\n        font-size: 1.2em;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
